/* global google */
import React from "react";
import { Marker } from "react-google-maps";

import Colors from "../../../../themes/Colors";

// Backend-clustered marker. PureComponent + stable handler keeps it cheap.
class ClusterMarker extends React.PureComponent {
  handleClick = () => this.props.onClick(this.props.cluster);

  render() {
    const { lat, lng, count } = this.props;
    const scale = Math.min(18 + Math.log10(Math.max(count, 1)) * 8, 38);
    return (
      <Marker
        position={{ lat, lng }}
        onClick={this.handleClick}
        icon={{
          path: google.maps.SymbolPath.CIRCLE,
          scale,
          fillColor: Colors.primary,
          fillOpacity: 0.85,
          strokeColor: Colors.white,
          strokeWeight: 2,
        }}
        label={{
          text: String(count),
          color: Colors.white,
          fontSize: "13px",
          fontWeight: "bold",
        }}
      />
    );
  }
}

export default ClusterMarker;
